import React from "react";
import TableHeadingChip from "../TableHeadingChip";
import { Disclosure } from "@headlessui/react";
import TableRow from "../TableRow";
import TableGroup from "./TableGroup";
const TableGIS = () => {
  return (
    <div className="w-full pt-8 overflow-x-auto max-w-full custom-dashboard-table-container gis-table">
      <div className="w-full mx-auto bg-white rounded-2xl  flex flex-col  custom-dashboard-table">
        <div className="flex -mb-8  ml-8">
          <div className="table-left-content"></div>
          <TableHeadingChip text={<>FEnterprise<br></br>Launch Kit</>} />
          <TableHeadingChip text={<>Cloud based EA<br></br>Launch Kit</>} />
          <TableHeadingChip text={<>AArcGIS Data<br></br>Health Checks</>} />
          <TableHeadingChip text={<>AGOL Launch<br></br>Kit</>} />
          <TableHeadingChip text={<>Field Operations<br></br>Launch Kit</>} />
        </div>
        <Disclosure defaultOpen={true}>
          {({ open }) => (
            <TableGroup
              title="Daily Use"
              isOpen={open}
              isFirst={true}
            >
              <TableRow
                content={{
                  title: "Level of technical knowledge required to operate",
                  values: ["Advance", "Advance", "Medium", "Medium", "Medium"],
                  // values: ["Medium",  "Medium", "Medium","Advance", "Advance"],
                }}
              />

            </TableGroup>
          )}
        </Disclosure>
        <Disclosure defaultOpen={true}>
          {({ open }) => (
            <TableGroup
              title="Population pre-requisites"
              isOpen={open}
            >
              <TableRow
                notbold={true}
                content={{
                  title: "My city's population size.",
                  values: ["Applicable for pop above 15k", "Applicable for pop below 15k", "Any size", "Won't qualify if Enterprise launch kit is offered", "Any size"],
                  // values: [
                  //   "Any size",
                  //   "Any size",
                  //   "Any size",
                  //   "less than 15K",
                  //   "larger than 15K"                                                        
                  // ],
                }}
              />
            </TableGroup>
          )}
        </Disclosure>
        <Disclosure defaultOpen={true}>
          {({ open }) => (
            <TableGroup title="General" isOpen={open}>
              {/* <TableGroup title="Foundational GIS Needs" isOpen={open}> */}
              <TableRow
                content={{
                  title:
                    "Introduce ArcGIS to my organization and jumpstart its use",
                  values: [false, false, false, true, false],
                }}
              />
              <TableRow
                content={{
                  title:
                    "Become self-sufficient and develop professional skill sets to use ArcGIS platform",  // new added row
                  values: [false, false, false, true, false],
                }}
              />
              <TableRow
                content={{
                  title: "Create automated field data collection apps",
                  // title: "Instant access to configurable maps and curated data",
                  values: [false, false, false, true, false],
                }}
              />
              <TableRow
                content={{
                  title:
                    "Fully leverage ArcGIS platform",
                  // "Become self-sufficient and develop professional skill sets to use ArcGIS platform",
                  values: [false, false, false, true, false],
                }}
              />
              <TableRow
                content={{
                  title:
                    "Increased spatial awareness about various above and underground utility assets",
                  // "Increased spatial awareness about various utility assets",
                  values: [false, false, false, false, true],
                }}
              />
              <TableRow
                content={{
                  title:
                    "Implement field data collection apps and extend automation",
                  values: [false, false, false, false, true],
                }}
              />
              <TableRow
                content={{
                  title:
                    "Expand the use of field data collection apps to reduce errors, boost productivity and save $$",
                  values: [false, false, false, false, true],
                }}
              />
            </TableGroup>
          )}
        </Disclosure>
        <Disclosure defaultOpen={true}>
          {({ open }) => (
            <TableGroup title="Quality of Data" isOpen={open}>
              {/* <TableGroup title="Data Quality &amp; Management" isOpen={open}> */}
              <TableRow
                content={{
                  title: "The quality of data in currently in use",
                  values: [true, true, true, false, false],
                }}
              />
              <TableRow
                content={{
                  title:
                    "Maintain the quality of the data with consistent and repeatable data review processes",
                  values: [true, true, true, false, false],
                }}
              />
              <TableRow
                content={{
                  title:
                    "Track, manage and monitor the status of organization's data at all times",
                  values: [true, true, true, false, false],
                }}
              />
              <TableRow
                content={{
                  title:
                    "Flexibility to use existing database infrastructure", //new added row
                  values: [true, true, false, false, false],
                }}
              />
            </TableGroup>
          )}
        </Disclosure>
        <Disclosure defaultOpen={true}>
          {({ open }) => (
            <TableGroup title="Advance use of ArcGIS" isOpen={open}>
              {/* <TableGroup title="Advanced GIS Needs" isOpen={open}> */}
              <TableRow
                content={{
                  title:
                    "Ability to scale my GIS infrastructure as my organization grows", 
                    // "Ability to scale GIS infrastructure at the rate of my organization’s growth", //moved at top
                  values: [true, true, false, false, false],
                }}
              />
                  <TableRow
                    content={{
                      title:
                        "Advanced control on how, when and what data is shared within organization and outside organizations",
                        // "Advanced control on how, when and what data is shared within - outside organizations", //moved to second
                      vvalues: [true, true, false, false, false],
                    }}
                  />
                  <TableRow
                    content={{
                      title:
                        "Access to Machine learning, artificial intelligence and python notebooks data science tools",  
                        // "Access to machine learning, AI and python notebooks data science tools",  //moved to third
                      values: [true, true, false, false, false],
                    }}
                  />
              <TableRow
                content={{
                  title:
                    "Process and store large quantity of tabular, vector and raster data",
                  values: [true, true, false, false, false],
                }}
              />
            </TableGroup>
          )}
        </Disclosure>
      </div>
    </div>
  );
};

export default TableGIS;
